exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singleSelectHeader__closeButton___Tk_XL {\n  float: right;\n  font-size: 20px;\n  color: #828282;\n  margin-top: 6px; }\n\n.singleSelectHeader__header___35DZL {\n  padding-bottom: 17px;\n  box-shadow: 0 1px 0 0 #dbdbdb;\n  margin-bottom: 15px; }\n\n.singleSelectHeader__title___3YMDw {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #292929; }\n", ""]);

// exports
exports.locals = {
	"closeButton": "singleSelectHeader__closeButton___Tk_XL",
	"header": "singleSelectHeader__header___35DZL",
	"title": "singleSelectHeader__title___3YMDw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/SingleSelectHeader/singleSelectHeader.scss
// module id = 2157
// module chunks = 6